module.exports = __webpack_public_path__ + "img/sol.8f48b6e8.svg";